import { Container, makeStyles, Typography } from '@material-ui/core';
import React, { ReactElement } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Helmet } from 'react-helmet';
import SocialFeedCard from '../../components/SocialFeedCard';
import { newsArticles } from '../../config';

const useStyles = makeStyles((theme) => ({
    title: {
        margin: '3rem',
    },
    newsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        marginBottom: '4rem',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        },
    },
    cardContainer: {
        margin: '1rem',
    },
}));

export default function NewsPage(): ReactElement {
    const classes = useStyles();

    return (
        <Container maxWidth="md">
            <Helmet>
                <title>London Insulation Services | News</title>
            </Helmet>
            <Typography className={classes.title} align="center" variant="h3">
                News Feed
            </Typography>
            <div className={classes.newsContainer}>
                <Fade>
                    {newsArticles.map(({ imageUrl, text, date, linkedinUrl }) => (
                        <div key={text} className={classes.cardContainer}>
                            <SocialFeedCard imageUrl={imageUrl} text={text} date={date} linkedinUrl={linkedinUrl} />
                        </div>
                    ))}
                </Fade>
            </div>
        </Container>
    );
}
